import React, { useCallback, useMemo } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { defined } from "@formant/core/common/defined";

import { useRouter } from "../../../context/RouterContext";
import { useStores } from "../../../context/StoreContext";
import { Header } from "../../common/Header";
import { ModuleAdd } from "../../common/ModuleAdd";
import { RestrictedComponent } from "../../common/RestrictedComponent";
import { StandardButton } from "../../common/StandardButton";
import { DeviceStatus } from "../../DeviceStatus";
import { EditViewHeader } from "../../EditViewHeader";
import styles from "../ViewDeviceHeader.scss";
import { IViewDeviceHeaderProps } from "./IViewDeviceHeaderProps";
import { TeleopButtons } from "./TeleopButtons";

export const CustomizeViewDeviceHeader = observer(
    function CustomizeViewDeviceHeader(props: IViewDeviceHeaderProps) {
        const { view, device, layoutType } = props;
        const id = defined(device.id);

        const { onlineDevicesStore } = useStores();
        const { navigate, routeTo } = useRouter();

        const handleTeleopClick = useCallback(async () => {
            await navigate(
                routeTo.editDevice({ id }, { tab: "Teleoperation" }),
            );
        }, [id]);

        const online = onlineDevicesStore.isOnline(id) || false;

        return (
            <Header
                title={device.name}
                className={classnames(
                    styles["view-device-header"],
                    styles.editing,
                )}
            >
                <EditViewHeader
                    view={view}
                    deviceIds={useMemo(() => [id], [id])}
                    isV2Dashboard={layoutType === "dashboard"}
                >
                    <DeviceStatus id={id} online={online} />
                </EditViewHeader>
                {layoutType === "teleop" && (
                    <RestrictedComponent
                        resource="teleop"
                        requiredAccess="administrator"
                    >
                        <TeleopButtons>
                            <StandardButton
                                onClicked={handleTeleopClick}
                                data-tooltip="Device Teleoperation Settings"
                            >
                                TELEOP SETTINGS
                            </StandardButton>
                            <ModuleAdd />
                        </TeleopButtons>
                    </RestrictedComponent>
                )}
            </Header>
        );
    },
);
